import { render, staticRenderFns } from "./ParameterStock.vue?vue&type=template&id=22304aa6&"
import script from "./ParameterStock.vue?vue&type=script&lang=js&"
export * from "./ParameterStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports